const env = process.env.NODE_ENV || "development";

let cache;

const config = () => {
	if (!cache) {
		cache = Object.freeze({
			env,
			secrets: {
				apiHost:
					process.env.REACT_APP_ENVIRONMENT === "development"
						? "https://core-staging.smartdeals.com.ng"
						: "https://core.smartdeals.com.ng",
				termsOfUse:
					process.env.REACT_APP_ENVIRONMENT === "development"
						? "https://docs-staging.smartdeals.com.ng/terms"
						: "https://docs.smartdeals.com.ng/terms",
				privacyPolicy:
					process.env.REACT_APP_ENVIRONMENT === "development"
						? "https://docs-staging.smartdeals.com.ng/privacy"
						: "https://docs.smartdeals.com.ng/privacy",
			},
		});
	}
	return cache;
};

export default config;
